import React from "react";
import { PrivacyTip } from "@mui/icons-material";
import LegalDocumentPage from "./LegalDocumentPage";

export const PRIVACY_URL = '/content/DropWyrmVTT-Privacy-Policy_1.0.md';

export default function PrivacyPolicyPage() {
    return <LegalDocumentPage url={PRIVACY_URL} title="Privacy Policy" Icon={PrivacyTip} />;
}
